import Appbase from "appbase-js";
import {get, isArray, sortBy} from "lodash";

class CustomSearch {
    constructor(props) {
        this.props = props;
        this.searchFieldNameInView = "";
        this.typeNameInView = "";
        this.maxExpectedResults = 1;
    }

    getAppbaseRef() {
        return Appbase({
            "url": this.props.esUrl,
            "app": this.props.modelIndexName,
        });
    }

    generateSearchCriteria(data) {
        return "";
    }

    generateSearchBody(searchCriteria) {
        return {
            body: {
                query: {
                    match_all: {}
                }
            }
        };
    }

    prepareData(res) {
        return res.hits.hits[0]._source;
    }

    prepareMetadata(res, data) {
        return {};
    }

    searchAndShow(type, data) {
        const searchCriteria = this.generateSearchCriteria(data);
        this.getAppbaseRef().search(
            this.generateSearchBody(searchCriteria)
        ).then(res => {

                if (res.hits.hits.length === 0) {
                    throw new Error("No "
                        + this.typeNameInView
                        + " found for "
                        + this.searchFieldNameInView
                        + " = "
                        + searchCriteria
                    );
                }
                if (this.maxExpectedResults && res.hits.hits.length > this.maxExpectedResults) {
                    throw new Error("Multiple "
                        + this.typeNameInView
                        + " found for "
                        + this.searchFieldNameInView
                        + " = "
                        + searchCriteria
                    );
                }
                this.props.showModal(
                    type,
                    this.prepareData(res),
                    this.prepareMetadata(res, data)
                );
            }).catch(
                err => this.props.onError(err, this.props.handleError)
        );
    };
}

export class ModelSearch extends CustomSearch {
    constructor(props) {
        super(props);
        this.searchFieldNameInView = "shortName";
        this.typeNameInView = "model(s)";
    }

    generateSearchCriteria(data) {
        return get(data, "model.shortName");
    }

    generateSearchBody(searchCriteria) {
        return {body: {query: {match: {"shortName.keyword": searchCriteria}}}};
    }

    prepareMetadata(res, data) {
        return {
            name: data.name,
            originatorShortName: data.model.originator.shortName,
            modelName: data.model.name,
            headerName: data.model.name,
            freeText: ""
        }
    }

    searchAndShow(data) {
        super.searchAndShow('MODEL', data)
    }
}

export class ParameterSearch extends CustomSearch {
    constructor(props) {
        super(props);
        this.searchFieldNameInView = "shortName";
        this.typeNameInView = "model(s)";
    }

    prepareMetadata(res, data) {
        return {
            name: data.name,
            originatorShortName: data.model.originator.shortName,
            modelName: data.model.name,
            headerName: data.name + " / " + data.longNameOriginator,
            freeText: ""
        }
    }

    searchAndShow(data) {
        this.props.showModal(
            'PARAMETER',
            data,
            this.prepareMetadata(null, data)
        );
    }
}

export class GridSearch extends CustomSearch {
    constructor(props) {
        super(props);
        this.searchFieldNameInView = "shortName";
        this.typeNameInView = "grid(s)";
        this.maxExpectedResults = null;
    }

    getAppbaseRef() {
        return Appbase({
            "url": this.props.esUrl,
            "app": this.props.gridIndexName,
        });
    }

    generateSearchCriteria(data) {
        return Array.from(
            new Set(
                Object.values(
                    data.dataFormat
                ).filter(entry => isArray(entry)).flatMap(
                    x => x.flatMap(
                        y => y.grid)
                )
            )
        );
    }

    generateSearchBody(searchCriteria) {
        return {body: {query: {bool: {filter: {terms: {"shortName.keyword": searchCriteria}}}}}};
    }

    prepareData(res) {
        const sortedGrids = sortBy(res.hits.hits.map(x => x._source), "shortName");
        let grids = {};
        sortedGrids.map(x => {
            grids[x.shortName] = x;
            return null;
        });
        return grids;
    }

    prepareMetadata(res, data) {
        return {
            name: data.shortName,
            originatorShortName: data.model.originator.shortName,
            modelName: data.model.name,
            headerName: "Grid: "
                + res.hits.hits
                    .map(x => x._source)
                    .map(y => y.shortName)
                    .sort()
                    .join(", "),
            freeText: ""
        }
    }

    searchAndShow(data) {
        super.searchAndShow('GRID', data)
    }
}

export class AccessSearch extends CustomSearch {
    constructor(props) {
        super(props);
        this.searchFieldNameInView = "storage";
        this.typeNameInView = "access";
    }

    generateSearchCriteria(data) {
        return get(data, "model.shortName");
    }

    generateSearchBody(searchCriteria) {
        return {body: {query: {match: {"shortName.keyword": searchCriteria}}}};
    }

    prepareMetadata(res, data) {
        return {
            name: data.name,
            originatorShortName: data.model.originator.shortName,
            modelName: data.model.name,
            headerName: "",
            freeText: "Please provide AWS account name/id to Model Data Squad to get access to the data."
        }
    }

    prepareData(res) {
        return  res.hits.hits[0]._source.notification.mg;
    }

    searchAndShow(data) {
        super.searchAndShow('ACCESS', data)
    }
}


// WEBPACK FOOTER //
// ./src/components/results/Searches.js